import React from "react";

import card from "assets/img/card-shadow.png";
import profile from "assets/img/profile.svg";
import calculator from "assets/img/calculator.svg";
import wallet from "assets/img/wallet.svg";
import lock from "assets/img/lock.svg";
import check from "assets/img/Rectangleblue.svg";

import "assets/styles/device/RegisterDevice.scss";

import TitleLeft from "components/common/sections/TitleLeft";
import Clearfix from "components/common/Clearfix";
import Card from "components/device/sections/RegisterDeviceCard";

const RegisterDevice = () => {
  return (
    <div className={'registerDeviceWrapper'}>
      <div className={'registerDevice'}>
        <div className={'header'}>
          <TitleLeft>Proceso de onboarding ágil y seguro para pagos con tarjeta presente</TitleLeft>
        </div>
      </div>
    </div>
  );
};

export default RegisterDevice;
